import { MenuItem } from 'ats-platform';

export const MENU: MenuItem[] = [];